// extracted by mini-css-extract-plugin
var _1 = "f3lpz";
var _2 = "baPZg";
export { _1 as "buttons", _2 as "empty" }
